import React from "react"

const PATCH_FLAG = "__sfg20LazyPatched"

function isRenderableComponent(value) {
    return (
        typeof value === "function" ||
        (typeof value === "object" && value !== null && typeof value.$$typeof === "symbol")
    )
}

function unwrapDefault(value) {
    let current = value
    const seen = new Set()
    for (let i = 0; i < 5; i++) {
        if (!current || typeof current !== "object" || seen.has(current)) {
            break
        }
        if (isRenderableComponent(current)) {
            return current
        }
        seen.add(current)
        if ("default" in current) {
            current = current.default
            continue
        }
        break
    }
    return current
}

if (!React[PATCH_FLAG]) {
    const originalLazy = React.lazy
    React.lazy = function patchedLazy(factory) {
        return originalLazy(async () => {
            const moduleObject = await factory()

            let resolved = unwrapDefault(moduleObject?.default ?? moduleObject)
            if (!isRenderableComponent(resolved) && moduleObject && typeof moduleObject === "object") {
                for (const candidate of Object.values(moduleObject)) {
                    const unwrapped = unwrapDefault(candidate)
                    if (isRenderableComponent(unwrapped)) {
                        resolved = unwrapped
                        break
                    }
                }
            }

            return { default: resolved }
        })
    }
    React[PATCH_FLAG] = true
}
